import Vue from 'vue'
import VClamp from 'vue-clamp'

Vue.component('v-clamp', VClamp)
